<template>
    <div class="col-12 col-md-auto">
        <div class="form-group form-group_date">
          <div class="form-group__icon svg-icon color-green_light" aria-hidden="true">
            <svg role="img" width="24" height="24" aria-hidden="true">
              <use xlink:href="#svg-icon-calendar"></use>
            </svg>
          </div>
          <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: 'filter-date',
}
</script>
<style scoped>

</style>